import { createAction } from 'redux-actions';
import * as types from './info-constants';

export const getCustomerInfoRequest = createAction(types.GET_CUSTOMER_INFO_REQUEST);
export const getCustomerInfoSuccess = createAction(types.GET_CUSTOMER_INFO_SUCCESS);
export const getCustomerInfoFailure = createAction(types.GET_CUSTOMER_INFO_FAILURE);
